import { styled } from "@mui/material/styles";
const ResultMain = styled("div")(({ theme }) => ({
  marginBottom: "20px",
}));
const ResultMainWrap = styled("div")(({ theme }) => ({
  background: "#FFFFFF",
  border: "1px solid #D1D1D1",
  boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.05)",
  borderRadius: "12px",
}));
const ResultHeader = styled("div")(({ theme }) => ({
  padding: "5px 13px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  a: {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "19px",
    color: "rgba(11, 11, 11, 0.75)",
    textDecoration: "none",
    fontFamily: theme.typography.fontFamily,
  },
  "& .order_id_main": {
    ".Order_ID": {
      fontFamily: theme.typography.fontFamily,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "18px",
      letterSpacing: "0em",
      color: "rgba(0, 0, 0, 0.6)",
    },
    ".dash": {
      fontFamily: theme.typography.fontFamily,
      fontSize: "14px",
      fontWeight: 900,
      lineHeight: "18px",
      letterSpacing: "0em",
      color: "rgba(0, 0, 0, 1)",
      padding: "0 5px",
    },
    ".order_id": {
      fontFamily: theme.typography.fontFamily,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "18px",
      letterSpacing: "0em",
      color: "rgba(0, 0, 0, 1)",
    },
  },
}));
const ResultMap = styled("div")(({ theme }) => ({
  borderTop: "1px solid #D1D1D1",
  height: "180px",
  overflow: "hidden",
  position: "relative",
  "& img": {
    width: "100%",
    height: "auto",
  },
  "& span": {
    background: "#0B0B0B",
    borderRadius: "64px",
    position: "absolute",
    top: "10px",
    right: "10px",
    width: "60px",
    height: "30px",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "8px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    color: "#FFFFFF",
    fontFamily: theme.typography.fontFamily,
    justifyContent: "center",
    cursor: "pointer",
  },
}));

export { ResultMain, ResultMainWrap, ResultHeader, ResultMap };
